import { useEffect, useRef } from "react"
import {
  PROGRAM_TERMINATION_TIMEOUT_MS,
  programFallbackReason,
} from "./programTermination"

const track = (name, properties) => {
  window.analytics?.track?.(name, properties)
}

/**
 * One Segment event per mount for the program-status ramp: a mismatch when
 * V3 and pga-backend disagree, or a fallback (with its reason) when the
 * program source could not answer. Codes only, no personal data.
 */
export const useTerminatedGateTracking = ({
  useProgramStatus,
  me,
  program,
  v3ShowsModal,
  showsTerminatedModal,
}) => {
  const hasTracked = useRef(false)

  useEffect(() => {
    if (!useProgramStatus || !me || program.loading || hasTracked.current) {
      return
    }
    // `latencyMs` is set by an effect after the query settles; wait for it so
    // the event never reports null. A timeout reports the timeout as the floor.
    if (!program.timedOut && program.latencyMs === null) return
    const latencyMs = program.timedOut
      ? PROGRAM_TERMINATION_TIMEOUT_MS
      : program.latencyMs

    const fallbackReason = programFallbackReason({
      useProgramStatus,
      ...program,
    })
    if (fallbackReason) {
      hasTracked.current = true
      track("Terminated Gate Fallback", {
        reason: fallbackReason,
        latencyMs,
        v3ShowsModal,
        v3TerminateCd: me.termination?.terminateCd || null,
      })
      return
    }

    if (v3ShowsModal === showsTerminatedModal) return

    hasTracked.current = true
    track("Terminated Gate Mismatch", {
      v3ShowsModal,
      programShowsModal: showsTerminatedModal,
      v3TerminationStatus: me.termination?.status || null,
      v3TerminateCd: me.termination?.terminateCd || null,
      programTerminateCd: program.termination?.terminateCd || null,
      programType: program.termination?.type || null,
      latencyMs,
    })
  }, [useProgramStatus, me, program, v3ShowsModal, showsTerminatedModal])
}
